import React, { useState } from "react";
import {
  PAPER_WIDTH_OPTIONS,
  getPaperWidth,
  getAutoPrint,
  setPaperWidth,
  setAutoPrint,
  applyPrinterPageStyle,
} from "../../utils/printerSettings";

export default function ModalPrinterSettings({ isOpen, onClose }) {
  const [selectedWidth, setSelectedWidth] = useState(getPaperWidth);
  const [autoPrint, setAutoPrintState] = useState(getAutoPrint);

  const handleSave = () => {
    setPaperWidth(selectedWidth);
    setAutoPrint(autoPrint);
    applyPrinterPageStyle();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-[min(1.17vw,12px)] shadow-xl w-[min(35vw,420px)] p-[min(2.93vw,30px)]">
        <div className="text-20 font-[700] mb-[min(2.34vw,24px)]">ตั้งค่าปริ้นเตอร์</div>

        {/* Paper Width */}
        <div className="mb-[min(2.15vw,22px)]">
          <div className="text-14 font-[600] text-[var(--color-grey-2)] mb-[min(0.78vw,8px)]">ขนาดกระดาษ</div>
          <div className="flex gap-[min(0.98vw,10px)]">
            {PAPER_WIDTH_OPTIONS.map((opt) => (
              <button
                key={opt.value}
                onClick={() => setSelectedWidth(opt.value)}
                className={`flex-1 py-[min(0.88vw,9px)] rounded-[min(0.78vw,8px)] border-[min(0.10vw,1.5px)] text-14 font-[500] transition-colors ${
                  selectedWidth === opt.value
                    ? "border-[var(--color-main)] bg-[var(--color-main)] text-white"
                    : "border-[#DCDCDC] bg-white text-[#333]"
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        {/* Auto Print Toggle */}
        <div className="mb-[min(2.93vw,30px)]">
          <div className="text-14 font-[600] text-[var(--color-grey-2)] mb-[min(0.78vw,8px)]">การปริ้น</div>
          <div className="flex gap-[min(0.98vw,10px)]">
            <button
              onClick={() => setAutoPrintState(true)}
              className={`flex-1 py-[min(0.88vw,9px)] rounded-[min(0.78vw,8px)] border-[min(0.10vw,1.5px)] text-14 font-[500] transition-colors ${
                autoPrint
                  ? "border-[var(--color-main)] bg-[var(--color-main)] text-white"
                  : "border-[#DCDCDC] bg-white text-[#333]"
              }`}
            >
              ปริ้นอัตโนมัติ
            </button>
            <button
              onClick={() => setAutoPrintState(false)}
              className={`flex-1 py-[min(0.88vw,9px)] rounded-[min(0.78vw,8px)] border-[min(0.10vw,1.5px)] text-14 font-[500] transition-colors ${
                !autoPrint
                  ? "border-[var(--color-main)] bg-[var(--color-main)] text-white"
                  : "border-[#DCDCDC] bg-white text-[#333]"
              }`}
            >
              แสดง dialog
            </button>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-[min(0.98vw,10px)]">
          <button
            onClick={onClose}
            className="flex-1 py-[min(0.88vw,9px)] rounded-[min(0.78vw,8px)] border-[min(0.10vw,1.5px)] border-[#DCDCDC] text-14 font-[500] text-[#333] bg-white"
          >
            ยกเลิก
          </button>
          <button
            onClick={handleSave}
            className="flex-1 py-[min(0.88vw,9px)] rounded-[min(0.78vw,8px)] text-14 font-[700] text-white btn-main-active"
          >
            บันทึก
          </button>
        </div>
      </div>
    </div>
  );
}
